import styled from "@emotion/styled";

export const TreeRoot = styled.ul<{ isExpanded?: boolean }>`
  position: sticky;
  top: 70px;
  list-style-type: none;
  height: fit-content;
  min-height: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    position: relative;
    top: 0;
  }
`;

export const TreeNode = styled.li`
  overflow: hidden;

  .childNode {
    display: grid;
    grid-template-rows: 0fr;
    grid-template-columns: 100%;
    transition: grid-template-rows 250ms ease-in-out;
    overflow: hidden;

    &.expanded {
      grid-template-rows: 1fr;
    }
  }
`;

export const TreeScrollWrapper = styled.div`
  position: relative;
  overflow: auto;
  margin-bottom: ${({ theme }) => theme.space.space16};
  max-height: calc(100dvh - 107px);
  padding-bottom: ${({ theme }) => theme.space.space24};
  overscroll-behavior: contain;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    max-height: calc(100dvh - 164px);
  }

  ::-webkit-scrollbar {
    width: 3px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 2px;
    background-color: ${({ theme }) => theme.colors.tone.marble};
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background-color: ${({ theme }) => theme.colors.tone.silver};
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: ${({ theme }) => theme.colors.tone.silver};
  }

  ::-webkit-scrollbar-thumb:active {
    background-color: ${({ theme }) => theme.colors.tone.silver};
  }
`;
